import { TIPO_EVENTO } from './comunidadPublicaciones.js';

/** Clave en `comunidad_publicaciones.metadata` tras envío carrusel Telegram. */
export const COMUNIDAD_TELEGRAM_CAROUSEL_SENT_AT = 'telegram_carousel_sent_at';

export function getComunidadTelegramCarouselSentAt(row) {
  const meta = row?.metadata && typeof row.metadata === 'object' ? row.metadata : {};
  const at = meta[COMUNIDAD_TELEGRAM_CAROUSEL_SENT_AT];
  return at != null && String(at).trim() ? String(at).trim() : null;
}

/** @returns {{ sent: boolean, label: string, at: string|null }} */
export function comunidadTelegramCarouselSentInfo(row, { eventsOnly = true } = {}) {
  if (eventsOnly && row?.publicacion_tipo !== TIPO_EVENTO) {
    return { sent: false, label: '—', at: null };
  }
  const at = getComunidadTelegramCarouselSentAt(row);
  if (!at) return { sent: false, label: 'No', at: null };
  return { sent: true, label: 'Sí', at };
}
